import * as React from 'react';
import styled from 'styled-components';
import TextInput from '@src/editor/components/TextInput';
import useClickAway from 'react-use/esm/useClickAway';
import useKey from 'react-use/esm/useKey';
import { useRef, useState } from 'react';
const Input = styled(TextInput) `
  padding-left: 24px;
  font-weight: 400;
  height: 40px;
  display: flex;
  justify-content: center;
`;
const AddComponent = (props) => {
    const [value, updateValue] = useState('');
    const ref = useRef(null);
    useClickAway(ref, () => props.onSave(value));
    useKey((e) => {
        const ENTER = 13;
        const ESCAPE = 27;
        if (e.keyCode === ENTER) {
            props.onSave(value);
        }
        if (e.keyCode === ESCAPE) {
            props.onSave('');
        }
        return false;
    });
    return (React.createElement("div", { ref: ref },
        React.createElement(Input, { value: value, name: "AddComponent", autoFocus: true, onChange: (e) => updateValue(e.target.value) })));
};
export default AddComponent;
